import React, { useEffect, useState } from "react";
import "./Header.css";
import Logo from "./Logo";
import { useCart } from "../../Modules/Hooks/useCart";
import { Link, NavLink, useLocation } from "react-router-dom";
import { ShoppingBag, Menu, X, Home, Info, Smartphone } from "lucide-react";

const NAV_LINKS = [
  { to: "/", label: "Меню", icon: Home, end: true },
  { to: "/about", label: "О нас", icon: Info },
  { to: "/install", label: "Приложение", icon: Smartphone },
];

const Header = () => {
  const { totalItems } = useCart();
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 8);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    setMenuOpen(false);
  }, [location.pathname]);

  useEffect(() => {
    document.body.style.overflow = menuOpen ? "hidden" : "";
    return () => {
      document.body.style.overflow = "";
    };
  }, [menuOpen]);

  return (
    <header
      className={`Header ${scrolled ? "Header--scrolled" : ""} ${
        menuOpen ? "Header--menuOpen" : ""
      }`}
    >
      <div className="Header--Inner">
        <Link to="/" className="Header--Logo" aria-label="На главную">
          <Logo />
        </Link>

        <nav className="Header--Nav" aria-label="Основная навигация">
          {NAV_LINKS.map(({ to, label, end }) => (
            <NavLink
              key={to}
              to={to}
              {...(end !== undefined ? { end } : {})}
              className={({ isActive }) =>
                `Header--NavLink ${isActive ? "is-active" : ""}`
              }
            >
              {label}
            </NavLink>
          ))}
        </nav>

        <div className="Header--Actions">
          <NavLink
            to="/cart"
            className={({ isActive }) =>
              `Header--Cart ${isActive ? "is-active" : ""} ${
                totalItems > 0 ? "has-items" : ""
              }`
            }
            aria-label={`Корзина, товаров: ${totalItems}`}
          >
            <ShoppingBag size={20} />
            <span className="Header--CartLabel">Корзина</span>
            {totalItems > 0 && (
              <span className="Header--CartBadge">{totalItems}</span>
            )}
          </NavLink>

          <button
            type="button"
            className="Header--Burger"
            aria-label={menuOpen ? "Закрыть меню" : "Открыть меню"}
            aria-expanded={menuOpen}
            onClick={() => setMenuOpen((v) => !v)}
          >
            {menuOpen ? <X size={22} /> : <Menu size={22} />}
          </button>
        </div>
      </div>

      <div className={`Header--Mobile ${menuOpen ? "is-open" : ""}`}>
        <div className="Header--MobileInner">
          <nav className="Header--MobileNav" aria-label="Мобильная навигация">
            {NAV_LINKS.map(({ to, label, icon: Icon, end }) => (
              <NavLink
                key={to}
                to={to}
                {...(end !== undefined ? { end } : {})}
                className={({ isActive }) =>
                  `Header--MobileLink ${isActive ? "is-active" : ""}`
                }
              >
                <Icon size={20} />
                <span>{label}</span>
              </NavLink>
            ))}
            <NavLink
              to="/cart"
              className={({ isActive }) =>
                `Header--MobileLink ${isActive ? "is-active" : ""}`
              }
            >
              <ShoppingBag size={20} />
              <span>Корзина</span>
              {totalItems > 0 && (
                <span className="Header--MobileBadge">{totalItems}</span>
              )}
            </NavLink>
          </nav>
        </div>
      </div>
    </header>
  );
};

export default Header;
